// extracted by mini-css-extract-plugin
export default {"sizesVertical":"ProductSizesVertical-sizesVertical-rzO","sizesVerticalInputAndBtns":"ProductSizesVertical-sizesVerticalInputAndBtns-OtG"};